import { ca } from '@cian/analytics';

/**
 * Событие клика по точке входа в разводящей модалке новостроек
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1495326003
 */
export function trackNewbuildingEntryPointClick(type: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_menu',
    action: 'click_sopr',
    label: 'newbuildings',
    page: {
      extra: {
        click_type: type,
      },
    },
  });
}
